import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { useMediaQuery } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import content_my from "./content_my.json";
import {
  ButtonStyled,
  CardContainer,
  CardDeco,
  CardImage,
  CardListContainer,
  CardQuote,
  CardText,
  CardTextContainer,
  CardTextOnlyContainer,
  GridContainerStyled,
  QuoteText,
} from "./styles";

export default function FreeStartHere(props) {
  const [solutions, setSolutions] = useState([]);
  const isMobile = useMediaQuery("(max-width:1200px)");

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    // const response = await dispatch(fetchHiredlyXContent(query));

    const response = content_my;

    const { secondCardSection } = response || {};
    setSolutions(secondCardSection);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonCTA = "Claim my free post";
  const buttonColour = "yellow";
  const posthog = usePostHog();

  function triggerInfoDialog() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "post_for_free_hiring_challenge",
    });
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <CardContainer>
        <CardListContainer>
          <CardTextContainer>
            <CardTextOnlyContainer>
              <CardText type={"title"}>
                Solve Your Biggest Hiring Challenge
              </CardText>
              <CardText type={"desc"}>
                Retail, Food & Beverage and Hospitality are among Malaysia’s
                largest youth employers — but also the most strained by{" "}
                <b>high turnover, staffing shortages, and tight margins.</b>
                <br />
                By removing the cost barrier, Hiredly helps businesses of all
                sizes:
                <br />
                <p>
                  <CheckCircleIcon height={24} width={24} />
                  Hire without worrying about recruitment costs
                </p>
                <p>
                  <CheckCircleIcon height={24} width={24} />
                  Get seen by the people who actually fit your jobs
                </p>
                <p>
                  <CheckCircleIcon height={24} width={24} />
                  Always have people ready to be hired
                </p>
              </CardText>
            </CardTextOnlyContainer>

            {!isMobile && (
              <>
                <ButtonStyled onClick={triggerInfoDialog}>
                  {buttonCTA}
                </ButtonStyled>
              </>
            )}
          </CardTextContainer>

          <CardQuote>
            <QuoteText>
              “Hiring is one of the biggest challenges businesses face. <br />
              <br /> By offering free postings, we’re helping companies focus on
              building strong teams instead of worrying about recruitment
              costs.”
            </QuoteText>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <CardImage src={solutions?.coverImage?.data?.attributes?.url} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "4px",
                }}
              >
                <QuoteText type={"small-text"}>Derek Toh</QuoteText>
                <QuoteText type={"small-text"} style={{ fontWeight: 400 }}>
                  CEO of Hiredly
                </QuoteText>
              </div>
            </div>

            <CardDeco>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="164"
                height="164"
                viewBox="0 0 164 164"
                fill="none"
              >
                <path
                  d="M164.001 95.0967C164.002 143.414 134.685 158.583 101.44 156.045C97.6252 155.754 94.8131 152.474 94.8131 148.648V132.962C94.8131 128.449 98.7187 125.008 103.212 124.595C126.239 122.48 131.751 101.602 132.156 86.7831C132.266 82.7864 128.894 79.722 124.896 79.722H102.501C98.2549 79.722 94.8131 76.2802 94.813 72.0345L94.8125 13.0972C94.8125 8.85148 98.2543 5.40963 102.5 5.40963L156.314 5.40971C160.559 5.40971 164.001 8.84098 164.001 13.0865L164.001 31.2926C164.001 45.6525 164.001 66.4099 164.001 95.0967Z"
                  fill="#261754"
                  fill-opacity="0.08"
                />
                <path
                  d="M69.1887 95.0967C69.189 143.414 39.8726 158.583 6.62735 156.045C2.81275 155.754 0.000591587 152.474 0.000591587 148.648V132.962C0.000591587 128.449 3.90619 125.008 8.39965 124.595C31.4267 122.48 36.938 101.602 37.3438 86.7831C37.4532 82.7864 34.0813 79.722 30.0832 79.722H7.68803C3.44236 79.722 0.00056107 76.2802 0.000522923 72.0345L3.46415e-05 13.0972C4.12397e-06 8.85148 3.44183 5.40963 7.68755 5.40963L61.5012 5.40971C65.7467 5.40971 69.1883 8.84098 69.1884 13.0865L69.1884 31.2926C69.1885 45.6525 69.1885 66.4099 69.1887 95.0967Z"
                  fill="#261754"
                  fill-opacity="0.08"
                />
              </svg>
            </CardDeco>
          </CardQuote>

          {isMobile && (
            <>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <ButtonStyled onClick={triggerInfoDialog}>
                  {buttonCTA}
                </ButtonStyled>
              </div>
            </>
          )}
        </CardListContainer>
      </CardContainer>
    </GridContainerStyled>
  );
}
